import React, { Component } from "react";
import ReactHtmlParser from "react-html-parser";
import { Modal } from "semantic-ui-react";
import { ThoughtLeader } from "../../../stores/CoursePreviewStore/Types";

interface Props {
  leader: ThoughtLeader;
}

interface State {
  showModal: boolean;
}

interface ModalProps {
  showModal: boolean;
  onClickShowModal: (e: any, val: boolean) => void;
  leader: ThoughtLeader;
}

const ThoughtLeaderModal: React.FC<ModalProps> = ({
  showModal,
  onClickShowModal,
  leader
}) => (
  <Modal
    size="mini"
    closeIcon
    open={showModal}
    onClose={e => onClickShowModal(e, false)}
    className="thought-leader-modal review-modal"
  >
    <Modal.Content>
      <div className="user">
        <img
          className="ui circular image profile-picture"
          src={leader.picture_url}
          alt=""
        />
        <div className="name">
          <h2 className="ui header">{leader.name}</h2>
        </div>
      </div>
      <p className="review-content">
        {/* @ts-ignore */}
        {ReactHtmlParser(leader.formatted_biography)}
      </p>
    </Modal.Content>
  </Modal>
);

class Leader extends Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false
    };
  }

  onClickShowModal = (e, val) => {
    e.preventDefault();
    this.setState({ showModal: val });
  };

  render() {
    const { leader } = this.props;
    const { showModal } = this.state;

    return (
      <div className="column" key={leader.id}>
        <div className="bg">
          <div className="image">
            <img src={leader.picture_url} />
          </div>
          <div className="ui fluid card">
            <div className="content">
              <h4 className="">{leader.name}</h4>
              {/* @ts-ignore */}
              <div className="description">
                {/* @ts-ignore */}
                {ReactHtmlParser(leader.formatted_biography.slice(0, 150))}{" "}
                {leader.formatted_biography.length > 150 && (
                  <a onClick={e => this.onClickShowModal(e, true)} href="#">
                    ...read more
                  </a>
                )}
              </div>
            </div>
            <div className="actions">
              {leader.website_url && (
                <a href={leader.website_url} target="_blank">
                  <svg
                    width="44"
                    height="44"
                    viewBox="0 0 44 44"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="22" cy="22" r="22" fill="#504257" />
                    <path
                      d="M19.9998 27.5501L18.2298 29.2701C17.7657 29.7342 17.1362 29.995 16.4798 29.995C15.8235 29.995 15.194 29.7342 14.7298 29.2701C14.2657 28.806 14.005 28.1765 14.005 27.5201C14.005 26.8637 14.2657 26.2342 14.7298 25.7701L19.2698 21.2201C19.7154 20.773 20.3159 20.5144 20.9469 20.4976C21.5778 20.4809 22.1911 20.7073 22.6598 21.1301L22.7798 21.2301C22.9695 21.4157 23.2251 21.5185 23.4904 21.5157C23.7558 21.5128 24.0092 21.4047 24.1948 21.2151C24.3805 21.0255 24.4832 20.7699 24.4804 20.5045C24.4776 20.2391 24.3695 19.9857 24.1798 19.8001C24.1234 19.7271 24.0633 19.657 23.9998 19.5901C23.1462 18.8474 22.0422 18.4569 20.9114 18.4978C19.7806 18.5386 18.7077 19.0077 17.9098 19.8101L13.3098 24.3601C12.5282 25.2109 12.1055 26.3308 12.1299 27.4858C12.1544 28.6409 12.6241 29.7419 13.4411 30.5589C14.258 31.3758 15.359 31.8456 16.5141 31.87C17.6692 31.8945 18.789 31.4717 19.6398 30.6901L21.3698 29.0001C21.5407 28.8137 21.6346 28.5696 21.6326 28.3168C21.6307 28.064 21.5332 27.8214 21.3595 27.6376C21.1859 27.4539 20.9492 27.3427 20.6969 27.3264C20.4446 27.3102 20.1956 27.3901 19.9998 27.5501V27.5501ZM30.6898 13.3101C29.8486 12.4741 28.7108 12.0049 27.5248 12.0049C26.3389 12.0049 25.2011 12.4741 24.3598 13.3101L22.6298 15.0001C22.459 15.1864 22.3651 15.4306 22.367 15.6834C22.3689 15.9361 22.4665 16.1788 22.6401 16.3626C22.8137 16.5463 23.0505 16.6575 23.3028 16.6737C23.555 16.69 23.8041 16.6101 23.9998 16.4501L25.7298 14.7301C26.194 14.266 26.8235 14.0052 27.4798 14.0052C28.1362 14.0052 28.7657 14.266 29.2298 14.7301C29.694 15.1942 29.9547 15.8237 29.9547 16.4801C29.9547 17.1365 29.694 17.766 29.2298 18.2301L24.6898 22.7801C24.2442 23.2272 23.6438 23.4858 23.0128 23.5026C22.3818 23.5193 21.7685 23.2929 21.2998 22.8701L21.1798 22.7701C20.9902 22.5844 20.7346 22.4817 20.4692 22.4845C20.2039 22.4874 19.9505 22.5955 19.7648 22.7851C19.5792 22.9747 19.4765 23.2303 19.4793 23.4957C19.4821 23.7611 19.5902 24.0144 19.7798 24.2001C19.8525 24.2744 19.9293 24.3445 20.0098 24.4101C20.8645 25.1505 21.9681 25.5395 23.0981 25.4987C24.2282 25.4579 25.3008 24.9903 26.0998 24.1901L30.6498 19.6401C31.4912 18.8042 31.9676 17.6693 31.9751 16.4833C31.9826 15.2974 31.5205 14.1566 30.6898 13.3101V13.3101Z"
                      fill="#fff"
                    />
                  </svg>
                </a>
              )}
              {leader.linkedin_url && (
                <a href={leader.linkedin_url} target="_blank">
                  <svg
                    width="44"
                    height="44"
                    viewBox="0 0 44 44"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="22" cy="22" r="22" fill="#504257" />
                    <path
                      d="M16.15 15.0652C16.15 16.206 15.225 17.1304 14.0833 17.1304C12.9417 17.1304 12.0167 16.206 12.0167 15.0652C12.0167 13.9252 12.9417 13 14.0833 13C15.225 13 16.15 13.9252 16.15 15.0652ZM16.1667 18.7826H12V32H16.1667V18.7826ZM22.8183 18.7826H18.6783V32H22.8192V25.0617C22.8192 21.2039 27.8433 20.8883 27.8433 25.0617V32H32V23.6309C32 17.1213 24.565 17.3584 22.8183 20.5628V18.7826Z"
                      fill="white"
                    />
                  </svg>
                </a>
              )}
              {leader.twitter_url && (
                <a href={leader.twitter_url} target="_blank">
                  <svg
                    width="44"
                    height="44"
                    viewBox="0 0 44 44"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="22" cy="22" r="22" fill="#504257" />
                    <path
                      d="M32 15.8942C31.2563 16.2154 30.4637 16.4283 29.6375 16.5317C30.4875 16.032 31.1363 15.2468 31.4412 14.3003C30.6488 14.7655 29.7738 15.0942 28.8412 15.2775C28.0887 14.4886 27.0162 14 25.8462 14C23.5763 14 21.7487 15.8142 21.7487 18.0382C21.7487 18.3582 21.7762 18.6658 21.8438 18.9588C18.435 18.7951 15.4188 17.1865 13.3925 14.736C13.0387 15.3403 12.8313 16.032 12.8313 16.7766C12.8313 18.1748 13.5625 19.4142 14.6525 20.1317C13.9937 20.1194 13.3475 19.9311 12.8 19.6345C12.8 19.6468 12.8 19.6628 12.8 19.6788C12.8 21.6406 14.2212 23.2702 16.085 23.6455C15.7512 23.7354 15.3875 23.7785 15.01 23.7785C14.7475 23.7785 14.4825 23.7637 14.2337 23.7095C14.765 25.3083 16.2725 26.4837 18.065 26.5218C16.67 27.5963 14.8988 28.2437 12.9813 28.2437C12.645 28.2437 12.3225 28.2289 12 28.1883C13.8162 29.3415 15.9688 30 18.29 30C25.835 30 29.96 23.8462 29.96 18.512C29.96 18.3335 29.9538 18.1612 29.945 17.9902C30.7588 17.4215 31.4425 16.7114 32 15.8942Z"
                      fill="white"
                    />
                  </svg>
                </a>
              )}
            </div>
          </div>
          <ThoughtLeaderModal
            showModal={showModal}
            onClickShowModal={this.onClickShowModal}
            leader={leader}
          />
        </div>
      </div>
    );
  }
}

export default Leader;
